export default "__VITE_ASSET__e990b200__"